import { manageInvitesReducer } from "./manageInvitesSlice";
import { combineReducers } from "redux";
import { dashboardReducer } from "./dashboardSlice";
import { propertieReducer } from "./propertieSlice";
import { templatesReducer } from "./templatesSlice";
import { agentReducer } from "./agentSlice";
import { commonReducer } from "./commonSlice";
import { subscriptionReducer } from "./subscriptionSlice";

const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  propertie: propertieReducer,
  manageInvites: manageInvitesReducer,
  templates: templatesReducer,
  subscription: subscriptionReducer,
  agent: agentReducer,
  common: commonReducer,
});

export default rootReducer;
